export function Cog2FullIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.73 2.783a1 1 0 00-1.461 0L9.967 4.177a1 1 0 01-.92.3l-1.873-.363a1 1 0 00-1.183.859l-.234 1.893a1 1 0 01-.569.784l-1.728.807a1 1 0 00-.452 1.39l.924 1.669a1 1 0 010 .968l-.924 1.67a1 1 0 00.452 1.39l1.728.806a1 1 0 01.57.784l.233 1.893a1 1 0 001.183.86l1.872-.363a1 1 0 01.921.299l1.302 1.394a1 1 0 001.462 0l1.302-1.394a1 1 0 01.92-.3l1.873.363a1 1 0 001.183-.859l.233-1.893a1 1 0 01.57-.784l1.728-.807a1 1 0 00.452-1.39l-.924-1.669a1 1 0 010-.968l.924-1.669a1 1 0 00-.452-1.39l-1.728-.807a1 1 0 01-.57-.784l-.233-1.893a1 1 0 00-1.183-.86l-1.872.363a1 1 0 01-.921-.299L12.73 2.783zM12 16a4 4 0 100-8 4 4 0 000 8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
